import { MapContainer, TileLayer, Marker, Tooltip, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useState } from "react";

import { Canvas } from "@react-three/fiber";
import { DoubleSide } from "three";
import { Text } from "@react-three/drei";
const CircularText = ({ text, radius }) => {
    return (
        <>
            {text.split("").map((char, i) => {
                const angle = (i / text.length) * Math.PI * 2;
                const x = radius * Math.cos(angle);
                const y = radius * Math.sin(angle);

                return (
                    <Text
                        key={i}
                        position={[x, y, 0.1]}
                        rotation={[0, 0, angle + Math.PI / 2]}
                        fontSize={0.5}
                        color="white"
                    >
                        {char}
                    </Text>
                );
            })}
        </>
    );
};
const HoverRing = ({ position, text, hoveredMarker }) => {
    if (!position) return null;
    return (
        <Canvas
            id={"canvas"}
            style={{
                position: "absolute",
                left: position[0] - 100,
                top: position[1] - 115,
                width: "200px",
                height: "200px",
                pointerEvents: "none",
                zIndex: 999999
            }}
        // className="rotate_aniation run"
        >
            <mesh rotation={[0, 0, 0]}>
                <ringGeometry args={[1, 1.6, 64]} center={true} />
                <meshBasicMaterial color="black" side={DoubleSide} />
            </mesh>
            <CircularText text={text} radius={1.25} />
        </Canvas>
    );
};

const World2 = () => {
    const [hoveredMarker, setHoveredMarker] = useState(null);
    const [ringPosition, setRingPosition] = useState(null);
    const [ringText, setRingText] = useState("");
    // Default and hover marker icons
    const defaultIcon = new L.Icon({
        iconUrl: "/pin.png",
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
    });

    const hoverIcon = new L.Icon({
        iconUrl: "/locationIcon.png",
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -40],
    });

    const dataArr = [
        { projectName: "Ayodhya", lat: 19.2718085, long: 73.0789615, ringText: "Ayodhya  • Shakti Group • " },
        { projectName: "Avantika", lat: 19.2718085, long: 73.0789615, ringText: "Avantika  • Shakti Group • " },
        { projectName: "Dwarka", lat: 19.2718085, long: 73.0789615, ringText: "Dwarka  • Shakti Group • " },
        { projectName: "Signature", lat: 19.2731481, long: 73.0565003, ringText: "Signature  • Shakti Group • " },
        { projectName: "Siyara Heights", lat: 19.257053, long: 73.1485535, ringText: "Siyara Heights  • Shakti Group • " },
        { projectName: "Sharda Serene", lat: 19.2469927, long: 73.1747389, ringText: "Sharda Serene  • Shakti Serene • " },
        { projectName: "Siyara Fortune", lat: 19.2828979, long: 73.0393671, ringText: "Siyara Fortune  • Shakti Group • " },
        { projectName: "My Heaven", lat: 19.1645687, long: 73.0763165, ringText: "My Heaven  • Mukta Group • " },
        { projectName: "Viva", lat: 19.2685433, long: 73.0505064, ringText: "Siyara Viva  • Shakti Group • " },
        { projectName: "Leela Prasad", lat: 19.191983, long: 72.9730415, ringText: "Leela Prasad  • Leela Prasad Group• " },
        { projectName: "Anand Bhavan", lat: 19.105731, long: 72.843238, ringText: "Anand Bhavan  • Jet Realty Group• " },
        { projectName: "Hill View", lat: 19.0670648, long: 72.8311432, ringText: "Hill View  • Nagpal Group • " },
        { projectName: "71 Midtown", lat: 19.0537275, long: 72.8834852, ringText: "71 Midtown  • Paradigm Group • " },
        { projectName: "Summer Queen", lat: 19.062688254601184, long: 72.83139934719358, ringText: "Summer Queen  • Nagpal Group • " },
        { projectName: "Alaknanada", lat: 19.1155859, long: 72.8334368, ringText: "Alaknanada  • Gurukrupa Group • " },
        { projectName: "Reclamation", lat: 19.052706, long: 72.8312965, ringText: "Reclamation  • Gurukrupa Group • " },
        { projectName: "Mangal", lat: 19.1051032, long: 72.8482568, ringText: "Mangal  • Mangal Group • " },
        { projectName: "Ananta Heights", lat: 19.1002292, long: 72.8469313, ringText: "Ananta Heights  • Disha Group • " },
        { projectName: "Goldstone", lat: 19.0594173, long: 72.8316173, ringText: "Goldstone  • Mirchandani Group • " },
        { projectName: "Kripanagar", lat: 19.1100972, long: 72.8410248, ringText: "Kripanagar  • Chandak Group • " },
        { projectName: "Panchkutir", lat: 19.097162, long: 72.8482596, ringText: "Panchkutir  • Panchkutir Group • " },
        { projectName: "Blue Heaven", lat: 19.0538671, long: 72.8258032, ringText: "Blue Heaven  • Blue Heaven Group • " },
        { projectName: "Superstar", lat: 19.06534, long: 72.82496640003296, ringText: "Superstar  • Paradigm Group • " },
        { projectName: "Triton", lat: 19.0774375, long: 72.8301059, ringText: "Triton  • Mirchandani Group • " },
        { projectName: "Villa Remedian", lat: 19.24161, long: 72.85591, ringText: "Villa Remedian  • Villa Remedian Group • " },
        { projectName: "Triveni", lat: 19.2213898, long: 72.83443, ringText: "Triveni  • Jet Build Group • " },
        { projectName: "Tirupati Avenue", lat: 19.2909918, long: 72.8603792, ringText: "Tirupati Avenue  • Tirupati Avenue Group • " },
        { projectName: "Paintora", lat: 19.2382304, long: 72.8475544, ringText: "Paintora  • Varadvinayak Group • " },
        { projectName: "Disha Ville Parle", lat: 19.2174433, long: 72.8514758, ringText: "Disha Ville Parle   •Disha Group • " },
        { projectName: "Tirupati Imperial", lat: 19.2970685, long: 72.8707237, ringText: "Tirupati Imperial  • Tirupati Group • " },
        { projectName: "Anantara", lat: 19.2226284, long: 72.8427917, ringText: "Anantara  • Paradigm Group • " },
        { projectName: "Ruby CHSL", lat: 19.2274722, long: 72.8221111, ringText: "Ruby CHSL  • Shri Sai Akar Group • " },
        { projectName: "Mesacon Green", lat: 19.1151458, long: 72.8408195, ringText: "Mesacon Green  • Mesacon Group • " },
        { projectName: "Mesacon Crown", lat: 19.1154049, long: 72.8430282, ringText: "Mesacon Crown  • Mesacon Group • " },
        { projectName: "Samriddhi", lat: 19.194111, long: 72.84909, ringText: "Samriddhi  • Jet realty Group • " },
        { projectName: "GBL", lat: 19.1072636, long: 72.8563691, ringText: "GBL  • GBL Group • " },
        { projectName: "Mozaic Homes", lat: 19.1798659, long: 72.8622931, ringText: "Mozaic Homes  • Mozaic Group • " },
        { projectName: "Sarvam", lat: 19.1075876, long: 72.8585774, ringText: "Sarvam  • Chandak Group • " },
        { projectName: "Riddhi Siddhi", lat: 19.1423504, long: 72.8317242, ringText: "Riddhi Siddhi  • Gurukrupa Group • " },
        { projectName: "Jay Krishna", lat: 19.1509336, long: 72.934828, ringText: "Jay Krishna  • Jay Krishna Group • " },
        { projectName: "Queen Lowns", lat: 19.0973962, long: 72.840208, ringText: "Queen Lowns  • Times Realty Group • " },
        { projectName: "Amalfi", lat: 19.1336565, long: 72.811207, ringText: "Amalfi  • Lotus Group • " },
        { projectName: "Aplite", lat: 18.9455966, long: 72.8344523, ringText: "Aplite  • Greenstone Group • " },
        { projectName: "Mitlani", lat: 18.9558798, long: 72.8231835, ringText: "Mitlani  • Mitlani Group • " },
        { projectName: "Prachi", lat: 19.028494, long: 72.841078, ringText: "Prachi  • Dipti Group • " },
        { projectName: "M4 Ocean", lat: 18.9644295, long: 72.8400241, ringText: "M4 Ocean  • M4 Ocean Group • " },
        { projectName: "Sarddha", lat: 19.0230785, long: 72.8545737, ringText: "Sarddha  • Sarddha Group • " },
    ];

    const ZoomLogger = () => {
        useMapEvents({
            zoomend: (e) => {
                console.log("Current Zoom Level:", e.target.getZoom());
                setHoveredMarker(null);
                setRingPosition(null);
                setRingText("");
            },
        });
        return null;
    };

    return (
        <div>
            <MapContainer
                center={[19.1421, 72.8548]}
                zoom={12}
                style={{ height: "100vh", width: "100vw" }}
                zoomControl={false}
                attributionControl={false}
            >
                <ZoomLogger /> {/* Logs zoom level changes */}
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                {dataArr.map((item, index) => (
                    <Marker
                        key={index}
                        position={[item.lat, item.long]}
                        icon={hoveredMarker === index ? hoverIcon : defaultIcon}
                        eventHandlers={{
                            mouseover: (e) => {
                                setHoveredMarker(index);
                                const { x, y } = e.containerPoint;
                                setRingPosition([x, y]);
                                setRingText(item.ringText);
                            },
                            mouseout: () => {
                                setHoveredMarker(null);
                                setRingPosition(null);
                                setRingText("");
                            },
                            dragstart: () => {
                                setHoveredMarker(null);
                                setRingPosition(null);
                                setRingText("");
                            },
                            click: () => console.log("lsjjuidf")
                        }}
                    >
                        {/* Always Visible Text Next to Pin */}
                        <Tooltip permanent direction="top" offset={[0, -35]} opacity={0.8}>
                            <span style={{ fontWeight: "bold", color: "#333" }}>{item.projectName}</span>
                        </Tooltip>

                        {/* Popup on Click */}
                    </Marker>
                ))}
            </MapContainer>
            <HoverRing position={ringPosition} text={ringText} hoveredMarker={hoveredMarker} />
        </div>
    );
};

export default World2;
